import { Skeleton } from "@/components/ui/skeleton"

export default function BranchGridSkeleton() {
  return (
    <div className="px-2 md:px-4 w-full max-w-7xl mx-auto animate-pulse">
      <div className="pt-4 pb-8">
        <div className="rounded-3xl bg-white shadow-sm border border-gray-100 px-5 py-6 relative overflow-hidden">
          {/* Header Skeleton */}
          <div className="flex justify-between items-center mb-6">
            <Skeleton className="h-8 w-40 rounded-lg" />
            <Skeleton className="h-6 w-24 rounded-full" />
          </div>

          {/* Search Bar Skeleton */}
          <div className="mb-8 flex items-center gap-3">
            <div className="relative flex-1">
              <Skeleton className="h-12 w-full rounded-xl" />
            </div>
            <Skeleton className="h-12 w-12 rounded-xl" />
          </div>

          {/* Grid Skeleton */}
          <div className="grid grid-cols-3 xs:grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 gap-3 md:gap-6">
            {Array.from({ length: 12 }).map((_, i) => (
              <div key={i} className="flex flex-col items-center gap-3 p-3 md:p-4 rounded-2xl border border-gray-100 bg-white">
                <Skeleton className="h-[46px] w-[34px] md:h-[64px] md:w-[48px] rounded-lg" />
                <Skeleton className="h-3 w-20 rounded-full" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}


